/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  DELETE_USER: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.klefki.delete.user',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'DELETE_USER' },
      },
    },
    DELETE_USER: {
      invoke: {
        id: 'deleteUser',
        src: 'deleteUser',
        onDone: {
          target: 'DELETE_USER_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'DELETE_USER_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    DELETE_USER_SUCCESS: {
      on: {
        START: { target: 'DELETE_USER' },
      },
    },
    DELETE_USER_FAILED: {
      on: {
        START: { target: 'DELETE_USER' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
